"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_TYPE = void 0;
var REPORT_TYPE;
(function (REPORT_TYPE) {
    REPORT_TYPE["RC"] = "RC";
    REPORT_TYPE["EE"] = "EE";
    REPORT_TYPE["TS"] = "360";
})(REPORT_TYPE = exports.REPORT_TYPE || (exports.REPORT_TYPE = {}));
